import React, { useState, useEffect } from 'react';
import axios from 'axios';
import { X, Loader, AlertCircle } from 'lucide-react';

export default function AssessmentPreviewModal({ jobId, jobRole, onClose }) {
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState('');
  const [questions, setQuestions] = useState([]);

  useEffect(() => {
    if (!jobId) return;
    fetchPreview();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [jobId]);

  const fetchPreview = async () => {
    try {
      setLoading(true);
      setError('');
      const res = await axios.get(`${process.env.REACT_APP_API_BASE_URL}/api/assessment/preview/${jobId}`);
      setQuestions(res.data.questions || []);
    } catch (err) {
      setError(err.response?.data?.message || 'No assessment has been generated for this job yet.');
    } finally {
      setLoading(false);
    }
  };

  if (!jobId) return null;

  return (
    <div className="modal-overlay" onClick={onClose}>
      <div className="modal-content" onClick={(e) => e.stopPropagation()} style={{ maxWidth: '760px', width: '90vw' }}>
        <div className="modal-header">
          <div>
            <h2>Assessment Preview</h2>
            <p>{jobRole} • Read-only — this is what candidates will see</p>
          </div>
          <button className="close-btn" onClick={onClose}><X size={20} /></button>
        </div>

        <div className="modal-body">
          {loading && (
            <div style={{ textAlign: 'center', padding: '30px', color: '#64748b' }}>
              <Loader size={28} />
              <p>Loading questions...</p>
            </div>
          )}
          {error && (
            <div style={{ textAlign: 'center', padding: '30px', color: '#dc2626' }}>
              <AlertCircle size={28} />
              <p>{error}</p>
            </div>
          )}
          {!loading && !error && questions.map((q, idx) => (
            <div key={q.id} style={{ marginBottom: '20px', paddingBottom: '16px', borderBottom: '1px solid #f1f5f9' }}>
              <p style={{ fontWeight: 600, color: '#1e293b', marginBottom: '10px' }}>
                {idx + 1}. {q.question}
                <span style={{
                  marginLeft: '8px', fontSize: '0.7rem', fontWeight: 600, textTransform: 'uppercase',
                  color: '#64748b', background: '#f1f5f9', padding: '2px 6px', borderRadius: '4px'
                }}>
                  {q.type === 'mcq' ? 'Multiple Choice' : q.type === 'coding' ? 'Coding' : 'Short Answer'}
                </span>
              </p>

              {q.type === 'mcq' && (
                <div style={{ display: 'flex', flexDirection: 'column', gap: '8px' }}>
                  {(q.options || []).map((opt) => (
                    <label key={opt} style={{ display: 'flex', alignItems: 'center', gap: '8px', color: '#94a3b8' }}>
                      <input type="radio" disabled />
                      <span>{opt}</span>
                    </label>
                  ))}
                </div>
              )}

              {(q.type === 'coding' || q.type === 'short_answer') && (
                <textarea
                  disabled
                  placeholder={q.type === 'coding' ? 'Candidate will write code here...' : 'Candidate will type an answer here...'}
                  rows={q.type === 'coding' ? 4 : 3}
                  style={{
                    width: '100%', padding: '10px', borderRadius: '6px', border: '1px solid #e2e8f0',
                    background: '#f8fafc', color: '#94a3b8',
                    fontFamily: q.type === 'coding' ? 'monospace' : 'inherit'
                  }}
                />
              )}
            </div>
          ))}
        </div>
      </div>
    </div>
  );
}